module.exports = __webpack_public_path__ + "img/vehicle-01.01a64573.png";